import { defineFetch } from 'resift';

const makeGetRole = defineFetch({
  displayName: 'Get Role',
  make: (id: string) => ({
    request: (expandMemberCount: boolean = true, expandPermissions: boolean = true) => ({ http }) =>
      http({
        method: 'GET',
        route: `/roles/${id}`,
        query: { expandMemberCount, expandPermissions },
      }),
  }),
});

export default makeGetRole;
